/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonWithZugaengeDto } from '../../models/person-with-zugaenge-dto';

export interface GetAllPersonenWithZugaenge$Plain$Params {
}

export function getAllPersonenWithZugaenge$Plain(http: HttpClient, rootUrl: string, params?: GetAllPersonenWithZugaenge$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PersonWithZugaengeDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllPersonenWithZugaenge$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PersonWithZugaengeDto>>;
    })
  );
}

getAllPersonenWithZugaenge$Plain.PATH = '/v1/personzugaenge';
